<template>
  <img
    v-if="src"
    v-bind="$attrs"
    :src="src"
    :alt="alt"
    @error="useNextSource"
  >
</template>

<script>
import { itemIconFallbackUrls, resolveItemIcon } from '../services/itemIcons'

export default {
  name: 'ItemIcon',
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sources: [],
      sourceIndex: 0,
      resolutionVersion: 0,
    }
  },
  computed: {
    src() {
      return this.sources[this.sourceIndex] || ''
    },
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.loadIcon()
      },
    },
  },
  methods: {
    async loadIcon() {
      const version = ++this.resolutionVersion
      this.sourceIndex = 0
      this.sources = itemIconFallbackUrls(this.item)

      const resolved = await resolveItemIcon(this.item)
      if (version !== this.resolutionVersion || !resolved) return

      this.sourceIndex = 0
      this.sources = itemIconFallbackUrls(this.item, resolved)
    },
    useNextSource() {
      if (this.sourceIndex < this.sources.length - 1) {
        this.sourceIndex += 1
      } else {
        this.sources = []
      }
    },
  },
}
</script>
